export   const formatPhoneNumber = (phone: string) => {
    const cleaned = phone.replace(/\D+/g, '');
    return cleaned.replace(/^(\d{3})(\d{3,4})(\d{4})$/, '010-$2-$3');
  };